module.exports = __webpack_public_path__ + "static/media/autumn.88d58050.jpg";